module.exports = __webpack_public_path__ + "static/img/icon-download.94c03d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toolbar/icon-download.png
// module id = 526
// module chunks = 2 3 5 6